export const DEFAULT_TALENT_MIN_PERCENTILE = 0;
export const DEFAULT_TALENT_MAX_PERCENTILE = 100;
export const DEFAULT_TALENT_MULTIPLIER = 1;
export const DEFAULT_MAX_SALARY = 900000000;
